import { Options, Vue } from 'vue-class-component';

import List from '@/pages/config/document-type/list/list.vue';

@Options({
  name: 'document-type',
  components: {
    'page-list': List,
  },
})
export default class EconomicSector extends Vue {
  public isIndexOnly() {
    return /^[/]?document-type[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
